// import Cookies from 'js-cookie';
import { Outlet } from 'react-router-dom';
import { CandidatePageLayout } from '../components';

const CandidatesLayout = () => {
    return (
        <CandidatePageLayout>
            <Outlet />
        </CandidatePageLayout>
    );
};

export default CandidatesLayout;
